import { useEffect, useState, useRef } from 'react';
import { authRouters } from '../routers/authRouters';
import registerAxiosInterceptor, { removeAxiosInterceptor } from '../shared/interceptor';
import { Outlet, Route, Routes, Navigate, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { appSetting } from 'shared/app-settings';
import { Toast } from 'primereact/toast';
import { useSelector } from 'react-redux';
function getParameterByName(name, url = window.location.href) {
  //name = name;
  //url = window.location.href;
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return '';
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function AuthLayout() {
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const [tm, setTm] = useState(null);
  const toast = useRef(null);

  useEffect(() => {
    //1. setup axios default interceptor
    registerAxiosInterceptor();

    // Cleanup: xóa interceptor khi component unmount
    return () => {
      removeAxiosInterceptor();
    };
  }, []);
  
  return (
    <>
      {/* <iframe src={sessionStorage.getItem('LMS_URL') + '?tm=' + tm} style={{ display: 'none' }}></iframe> */}
      <Toast position='top-center' ref={toast} />
      <ConfirmDialog header="Thông báo" />
      <Routes>

        {authRouters.map(({ path, component: Component }, index) =>
          <Route path={path} key={index} element={<Component />} />
        )}
        <Route path="*" element={<Navigate to="/overview" />} />
      </Routes>
      <Outlet />
    </>
  )

}
export default AuthLayout;
